<script type="text/jsx">
import { DateUtility } from 'packages/utilities/DateUtility';
import moment from 'moment/moment';

export default {
    functional: true,
    props: {
        date: {
            type: String,
            default: null,
        },
        format: {
            type: String,
            default: null,
        },
        toLocal: {
            type: Boolean,
            default: null,
        },
    },
    render(h, { data, props }) {
        if (!props.date) {
            return;
        }

        let date;

        if (!props.toLocal) {
            date = new DateUtility(props.date);
        } else {
            date = new DateUtility(moment.utc(props.date).local().format());
        }

        return <time {...data}
            v-tooltip={date.format('dddd, DD.MM.YYYY HH:mm')}
            datetime={date.format('YYYY-MM-DD HH:mm')}
            class="cursor-default">
            {(props.format === 'from')
                ? date.moment.from(new Date())
                : date.format(props.format || null)
            }
        </time>;
    },
};
</script>
